import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { MapPin, Clock, Phone, Car, Accessibility, Navigation, Coffee, XCircle } from 'lucide-react';
import { Button } from '../components/ui/button';

export function VisitPage() {
    const handleGetDirections = () => {
        // Open Google Maps with Burston Garden Centre location in St. Albans
        window.open('https://www.google.com/maps/dir/?api=1&destination=Burston+Garden+Centre+North+Orbital+Road+Chiswell+Green+St+Albans+AL2+2DS', '_blank');
    };

    return (
        <div className="page-container" data-testid="visit-page">
            <PageHeader title="Visit Burston" showBack />
            
            <div className="px-4 py-4">
                {/* Map Placeholder */}
                <div className="rounded-3xl overflow-hidden mb-6 border-2 border-primary/10">
                    <div className="h-48 bg-primary/5 flex items-center justify-center relative">
                        <img 
                            src="https://api.mapbox.com/styles/v1/mapbox/streets-v12/static/-0.3607,51.7204,14,0/400x200@2x?access_token=pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4NXVycTA2emYycXBndHRqcmZ3N3gifQ.rJcFIG214AriISLbB6B5aw"
                            alt="Map of Burston Garden Centre"
                            className="w-full h-full object-cover opacity-70"
                            onError={(e) => {
                                e.target.style.display = 'none';
                            }}
                        />
                        <div className="absolute inset-0 flex items-center justify-center bg-primary/10">
                            <MapPin className="w-12 h-12 text-primary" />
                        </div>
                    </div>
                    <Button
                        onClick={handleGetDirections}
                        className="w-full h-14 rounded-none text-lg font-bold"
                        data-testid="get-directions-btn"
                    >
                        <Navigation className="w-5 h-5 mr-2" />
                        Get Directions
                    </Button>
                </div>

                {/* Address */}
                <div className="card-base mb-4" data-testid="address-card">
                    <div className="flex items-start gap-4">
                        <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                            <MapPin className="w-6 h-6 text-primary" />
                        </div>
                        <div>
                            <h3 className="font-bold text-foreground mb-1">Address</h3>
                            <p className="text-muted-foreground">
                                Burston Garden Centre<br />
                                North Orbital Road<br />
                                Chiswell Green<br />
                                St. Albans, Herts AL2 2DS
                            </p>
                        </div>
                    </div>
                </div>

                {/* Phone */}
                <div className="card-base mb-4" data-testid="phone-card">
                    <a href="tel:01727832444" className="flex items-center gap-4">
                        <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                            <Phone className="w-6 h-6 text-primary" />
                        </div>
                        <div>
                            <h3 className="font-bold text-foreground mb-1">Contact Us</h3>
                            <p className="text-primary font-medium text-lg">01727 832444</p>
                        </div>
                    </a>
                </div>

                {/* Opening Times */}
                <div className="card-base mb-4" data-testid="opening-times-card">
                    <div className="flex items-start gap-4">
                        <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                            <Clock className="w-6 h-6 text-primary" />
                        </div>
                        <div className="flex-1">
                            <h3 className="font-bold text-foreground mb-3">Opening Times</h3>
                            
                            <p className="font-bold text-primary mb-2">March to December</p>
                            <div className="space-y-1 text-muted-foreground mb-4">
                                <div className="flex justify-between">
                                    <span>Monday - Saturday</span>
                                    <span className="font-medium text-foreground">8:30am - 5:30pm</span>
                                </div>
                                <div className="flex justify-between">
                                    <span>Sunday</span>
                                    <span className="font-medium text-foreground">10am - 4:30pm</span>
                                </div>
                            </div>

                            <p className="font-bold text-primary mb-2">January & February</p>
                            <div className="space-y-1 text-muted-foreground">
                                <div className="flex justify-between">
                                    <span>Monday - Saturday</span>
                                    <span className="font-medium text-foreground">9am - 5pm</span>
                                </div>
                                <div className="flex justify-between">
                                    <span>Sunday</span>
                                    <span className="font-medium text-foreground">10am - 4:30pm</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Restaurant Hours */}
                <div className="card-base mb-4" data-testid="restaurant-hours-card">
                    <div className="flex items-start gap-4">
                        <div className="w-12 h-12 rounded-full bg-accent/10 flex items-center justify-center flex-shrink-0">
                            <Coffee className="w-6 h-6 text-accent" />
                        </div>
                        <div className="flex-1">
                            <h3 className="font-bold text-foreground mb-3">Restaurant Hours</h3>
                            
                            <p className="font-bold text-accent mb-2">March to December</p>
                            <div className="space-y-1 text-muted-foreground mb-4">
                                <div className="flex justify-between">
                                    <span>Monday - Saturday</span>
                                    <span className="font-medium text-foreground">8:30am - 5pm</span>
                                </div>
                                <div className="flex justify-between">
                                    <span>Sunday</span>
                                    <span className="font-medium text-foreground">10am - 4pm</span>
                                </div>
                            </div>

                            <p className="font-bold text-accent mb-2">January & February</p>
                            <div className="space-y-1 text-muted-foreground">
                                <div className="flex justify-between">
                                    <span>Monday - Saturday</span>
                                    <span className="font-medium text-foreground">9am - 4pm</span>
                                </div>
                                <div className="flex justify-between">
                                    <span>Sunday</span>
                                    <span className="font-medium text-foreground">10am - 4pm</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Closed Days */}
                <div className="card-base mb-4 bg-accent/5 border-accent/20" data-testid="closed-days-card">
                    <div className="flex items-start gap-4">
                        <div className="w-12 h-12 rounded-full bg-accent/10 flex items-center justify-center flex-shrink-0">
                            <XCircle className="w-6 h-6 text-accent" />
                        </div>
                        <div>
                            <h3 className="font-bold text-foreground mb-1">Closed</h3>
                            <p className="text-muted-foreground">
                                Christmas Day, Boxing Day, New Year's Day, Easter Sunday
                            </p>
                        </div>
                    </div>
                </div>

                {/* Facilities */}
                <h2 className="text-lg font-bold text-foreground mt-8 mb-4">Facilities</h2>
                
                <div className="space-y-3">
                    <div className="card-base">
                        <div className="flex items-start gap-4">
                            <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                                <Car className="w-5 h-5 text-primary" />
                            </div>
                            <div>
                                <h3 className="font-bold text-foreground">Parking</h3>
                                <p className="text-muted-foreground text-sm">
                                    Free parking with disabled spaces near the entrance
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="card-base">
                        <div className="flex items-start gap-4">
                            <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                                <Accessibility className="w-5 h-5 text-primary" />
                            </div>
                            <div>
                                <h3 className="font-bold text-foreground">Accessibility</h3>
                                <p className="text-muted-foreground text-sm">
                                    Level access throughout. Accessible toilets available. 
                                    Wheelchairs available on request. Seating areas throughout the garden centre.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default VisitPage;
